const getOptimalLimit = (containerH, elementH, gap) => {
  return Math.ceil(containerH / (elementH + gap));
};

export default getOptimalLimit;
